module.exports = __webpack_public_path__ + "static/img/wx_ewm.898a8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx_ewm.png
// module id = JB/D
// module chunks = 17